export const LIST_TYPE_BENEFICIARY = [
  {
    key: "beneficiary-legal",
    icon: "RideIcFamilyLight",
    title: "Herederos legales",
    tag: "Herederos legales",
    description:
      "Son aquellos designados por ley, como hijos, cónyuge, padres, etc.",
  },
  {
    key: "beneficiary-custom",
    icon: "RideIcAddUserLight",
    title: "Elige a tus beneficiarios",
    tag: "Elegir beneficiarios",
    description:
      "Decide quiénes serán y qué porcentaje del monto recibirá cada uno.",
  },
];

export const VE_LIST_TYPE_BENEFICIARY = [
  {
    key: "beneficiary-legal",
    icon: "RideIcFamilyLight",
    title: "Herederos legales",
    tag: "Herederos legales",
    description:
      "Son aquellos designados por ley, como hijos, cónyuge, padres, etc.",
  },
  {
    key: "beneficiary-custom",
    icon: "RideIcAddUserLight",
    title: "Agrega a tus beneficiarios",
    tag: "Elegir beneficiarios",
    description:
      "Decide quiénes serán y qué porcentaje del monto recibirá cada uno.",
  },
];